exports.components = {
  "component---plugins-gatsby-theme-cara-src-templates-cara-tsx": () => import("./../../../plugins/gatsby-theme-cara/src/templates/cara.tsx" /* webpackChunkName: "component---plugins-gatsby-theme-cara-src-templates-cara-tsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */)
}

